module.exports = __webpack_public_path__ + "static/media/icon-logo.2a7ccaef.svg";